exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pace {\n  -webkit-pointer-events: none;\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.pace-inactive {\n  display: none; }\n\n.pace .pace-progress {\n  background: #388E3C;\n  position: absolute;\n  z-index: 2000;\n  top: 0;\n  right: 100%;\n  width: 100%;\n  height: 5px; }\n", ""]);

// exports
